import map from 'lodash/map';
import coreBreadcrumbs from '@plone/volto/reducers/breadcrumbs/breadcrumbs';
import { GET_BREADCRUMBS } from '@plone/volto/constants/ActionTypes';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

/**
 * Wraps Volto's breadcrumbs reducer so that it keeps the answer of
 * `@breadcrumbs`. With the breadcrumbs expander, which Volto sets for every
 * path, the core reducer takes the breadcrumbs only from the content and
 * drops that answer, `loading` even stays set (the `if (!hasExpander)` guard
 * of `GET_BREADCRUMBS_SUCCESS` in reducers/breadcrumbs/breadcrumbs.js, line
 * 67 in Volto 19.3.0). The contents view requests no content, so
 * `contentsActions` loads its breadcrumbs with `getBreadcrumbs` (#22811).
 * Volto itself only asks for them without the expander; every other action,
 * above all `GET_CONTENT_SUCCESS` with the expander, stays Volto's.
 * @function breadcrumbs
 * @param {Object} state Current state
 * @param {Object} action Action to be handled
 * @returns {Object} New state
 */
export default function breadcrumbs(state, action = {}) {
  const next = coreBreadcrumbs(state, action);
  if (action.type !== `${GET_BREADCRUMBS}_SUCCESS`) {
    return next;
  }
  return {
    ...next,
    error: null,
    items: map(action.result.items, (item) => ({
      title: item.title,
      url: flattenToAppURL(item['@id']),
    })),
    root: flattenToAppURL(action.result.root),
    loaded: true,
    loading: false,
  };
}
